import { Building2, Users } from 'lucide-react';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '../../components/ui/tabs';
import OrganizationSettings from '../../components/organization-settings';
import DepartmentSettings from '../../components/department-settings';

export default function SettingsPage() {
  return (
    <div>
      <h1 className="text-lg font-semibold mb-4">Settings</h1>

      <Tabs defaultValue="organization">
        <TabsList className="bg-gray-100 p-0.5 rounded-lg mb-3 h-8">
          <TabsTrigger
            value="organization"
            className="data-[state=active]:bg-white data-[state=active]:shadow-sm rounded-md px-3 py-1 text-xs flex items-center gap-1.5"
          >
            <Building2 className="h-3 w-3" />
            Organization
          </TabsTrigger>
          <TabsTrigger
            value="departments"
            className="data-[state=active]:bg-white data-[state=active]:shadow-sm rounded-md px-3 py-1 text-xs flex items-center gap-1.5"
          >
            <Users className="h-3 w-3" />
            Departments
          </TabsTrigger>
        </TabsList>

        <TabsContent value="organization" className="mt-0">
          <OrganizationSettings />
        </TabsContent>

        <TabsContent value="departments" className="mt-0">
          <DepartmentSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}
